import type { JSX } from 'react';

import InnerContainer from '../../components/Layout/InnerContainer';
import { PageHeader } from '../../components/PageHeader/PageHeader';

import TeamMembers from './TeamMembers/TeamMembers';

export default function Users(): JSX.Element {
  return (
    <InnerContainer>
      <PageHeader title="Users" description="Invite, assign roles, and manage access." />
      <TeamMembers />
    </InnerContainer>
  );
}
